module.exports = __webpack_public_path__ + "static/install-afcdd60cd51b5ac6a76faa62b9e121e3.png";